import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Clock, Facebook } from "lucide-react";
import { SITE } from "@/data/site";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#0a0a0a] border-t border-white/10 relative grain">
    <div className="max-w-7xl mx-auto px-6 py-24">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-16">
        <div>
          <img src="/logo.png" alt="JCD Customs & Marine logo" className="h-28 w-auto mb-6" data-testid="footer-logo" />
          <p className="text-gray-400 text-sm max-w-xs">
            Hot rods, servicing, WOF, alignment, engineering and marine — all under one roof in Whangamata.
          </p>
        </div>
        <div>
          <p className="label-industrial text-ember mb-6">Find Us</p>
          <ul className="space-y-4 text-sm text-gray-300">
            <li className="flex items-start gap-3" data-testid="footer-address">
              <MapPin className="w-4 h-4 mt-0.5 text-ember shrink-0" /> {SITE.location}
            </li>
            <li className="flex items-start gap-3" data-testid="footer-phone">
              <Phone className="w-4 h-4 mt-0.5 text-ember shrink-0" /> {SITE.phone}
            </li>
            <li className="flex items-start gap-3" data-testid="footer-email">
              <Mail className="w-4 h-4 mt-0.5 text-ember shrink-0" /> {SITE.email}
            </li>
            <li data-testid="footer-facebook">
              <a href={SITE.facebook} target="_blank" rel="noopener noreferrer"
                className="flex items-start gap-3 hover:text-ember transition-colors duration-150">
                <Facebook className="w-4 h-4 mt-0.5 text-ember shrink-0" /> Follow us on Facebook
              </a>
            </li>
          </ul>
        </div>
        <div>
          <p className="label-industrial text-ember mb-6">Hours</p>
          <ul className="space-y-3 text-sm text-gray-300">
            {SITE.hours.map((h) => (
              <li key={h.days} className="flex items-start gap-3">
                <Clock className="w-4 h-4 mt-0.5 text-ember shrink-0" />
                <span className="flex-1 flex justify-between gap-4">
                  <span>{h.days}</span>
                  <span className="text-gray-500">{h.time}</span>
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="mt-20 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-4 text-xs text-gray-600">
        <span>© {new Date().getFullYear()} {SITE.name}. All rights reserved.</span>
        <Link to="/admin" data-testid="footer-admin-link" className="hover:text-ember transition-colors duration-150">
          Staff Login
        </Link>
      </div>
    </div>
  </footer>
);
